import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import ProductCard from '../../components/product_card';
import {
    Grid,
    Modal,
    Box,
    FormControl,
    Button,
    InputLabel,
    Select,
    MenuItem,
    TextField,
    IconButton,
    Typography,
    Card
} from '@mui/material';
import productApi from '../../services/product';
import { setEncryptedCookie, getDecryptedCookie, removeCookie } from '../../utils';
import { useDispatch, useSelector } from 'react-redux';
import { showLoader, hideLoader } from '../../redux/loader/actions';
import InfoIcon from '@mui/icons-material/Info';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import SubscribeIcon from '@mui/icons-material/Subscriptions';
import CloseIcon from '@mui/icons-material/Close';
import { makeStyles } from '@mui/styles';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EditIcon from '@mui/icons-material/Edit';
const useStyles = makeStyles({
    animatedButton: {
        background: 'linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)',
        color: '#fff !important',
        padding: '10px 30px',
        fontSize: '16px',
        fontWeight: 'bold',
        textTransform: 'none',
        borderRadius: '5px',
        transition: 'transform 0.3s ease',
        '&:hover': {
            transform: 'scale(1.05)',
            background: 'linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)'
        }
    },
    gridItemNoPaddingTop: {
        '& .css-mhc70k-MuiGrid-root > .MuiGrid-item': {
            paddingTop: 0
        }
    }
});
const ProductList = () => {
    const classes = useStyles();
    const menuItems = useSelector((state) => state.menuReducer.items);
    const createMenuItem = menuItems?.find((item) => item.name.toLowerCase() === 'products');
    const isDisabled = createMenuItem?.access_type === 'read_write';
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const organizationItems = useSelector((state) => state.organizationReducer.items);
    const [productList, setProductList] = useState([]);
    const [openModal, setOpenModal] = useState(false);

    useEffect(() => {
        removeCookie('proid');
        removeCookie('upid');
        removeCookie('action');
        removeCookie('upgrade');
        removeCookie('type');
    }, []);

    const handleButtonClick = (uuid, action, productUrl) => {
        action = action.toLowerCase();

        if (action === 'trial' || action === 'new') {
            navigate(`/products/plan`);
            setEncryptedCookie('proid', uuid, { expires: 7 });
            setEncryptedCookie('action', action, { expires: 7 });
        } else if (action === 'details') {
            window.open(productUrl, '_blank');
        }
    };

    const getAllProductList = useCallback(() => {
        dispatch(showLoader());
        productApi
            .getAllProduct()
            .then((res) => {
                if (res?.data?.status === true) {
                    setTimeout(() => {
                        dispatch(hideLoader());
                    }, 2000);
                    const filteredProducts = res?.data?.data.filter((product) => product.status === true);
                    setProductList(filteredProducts);
                }
            })
            .catch((err) => {
                dispatch(hideLoader());
                console.error('Error response:', err);
            });
    }, [dispatch]);

    useEffect(() => {
        getAllProductList();
    }, [getAllProductList, organizationItems]);

    const handleCloseModal = () => {
        setOpenModal(false);
    };
    const [businessModalOpen, setBusinessModalOpen] = useState(false);

    const handleOpenBusinessModal = () => {
        setOpenModal(false);
        setBusinessModalOpen(true);
    };

    const handleCloseBusinessModal = () => {
        setBusinessModalOpen(false);
    };

    const [selectedCard, setSelectedCard] = useState(null);
    const handleCardClick = (index) => {
        setSelectedCard(index);
    };

    return (
        <>
            <Grid container spacing={2}>
                {productList.length > 0 ? (
                    productList.map((product) => (
                        <Grid item xs={12} sm={12} md={4} key={product.id}>
                            <ProductCard
                                title={product.name
                                    .split(' ')
                                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                                    .join(' ')}
                                description={product.description || ''}
                                productUrl={product.productUrl}
                                url={product.product_url ? product.product_url : ''}
                                buttons={[
                                    {
                                        title: 'details',
                                        icon: <InfoIcon />,
                                        onClick: () => handleButtonClick(product.uuid, 'details', product.product_url),
                                        color: '#a71307'
                                    },
                                    product.trial_used !== true &&
                                        isDisabled && {
                                            title: 'trial',
                                            icon: <PlayArrowIcon />,
                                            onClick: () => handleButtonClick(product.uuid, 'trial', product.productUrl),
                                            color: '#765511'
                                        },
                                    isDisabled && {
                                        title: 'subscribe',
                                        icon: <SubscribeIcon />,
                                        onClick: () => handleButtonClick(product.uuid, 'new', product.productUrl),
                                        color: '#567e0f'
                                    }
                                ].filter(Boolean)}
                            />
                        </Grid>
                    ))
                ) : (
                    <Grid item xs={12}></Grid>
                )}

                {/* <Grid item xs={12} sm={12} md={4}>
          <ProductCard
            title="Communication Channel Service"
            description="This is a Communication Channel Service description."
            url="#"
            buttons={[
              {
                title: "details",
                icon: <InfoIcon />,
                onClick: () => console.log("data"),
                color: "#a71307",
              },
              {
                title: "trial",
                icon: <PlayArrowIcon />,
                onClick: () => console.log("data"),
                color: "#765511",
              },
              {
                title: "subscribe",
                icon: <SubscribeIcon />,
                onClick: () => setOpenModal(true),
                color: "#567e0f",
              },
            ]}
          />
        </Grid> */}
            </Grid>

            {/* Modal */}
            <Modal
                open={openModal}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        handleCloseModal();
                    }
                }}
                disableEscapeKeyDown
                disablePortal
                sx={{
                    backdropFilter: 'none',
                    '& .MuiBackdrop-root': {
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        filter: 'none',
                        backdropFilter: 'none'
                    }
                }}
            >
                <Box
                    sx={{
                        position: 'fixed',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        backgroundColor: 'white',
                        width: '70%',
                        maxHeight: '83vh',
                        overflowY: 'auto',
                        zIndex: 1300,
                        boxShadow: 24,
                        borderRadius: 4,
                        padding: '30px',
                        position: 'relative'
                    }}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography
                            variant='caption'
                            color='primary'
                            sx={{
                                marginLeft: 'auto',
                                marginRight: '30px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Note: 1 credit = 1000 SMS
                        </Typography>

                        <IconButton onClick={handleCloseModal}>
                            <CloseIcon sx={{ color: '#a00' }} />
                        </IconButton>
                    </Box>

                    <Grid container spacing={2} alignItems='center' sx={{ mt: 2 }}>
                        <Grid item xs={12} md={3}>
                            <FormControl fullWidth>
                                <InputLabel>Communication Type</InputLabel>
                                <Select name='type' label='type'>
                                    <MenuItem value='sms'>SMS</MenuItem>
                                    <MenuItem value='email'>Email</MenuItem>
                                    <MenuItem value='whatsapp'>Whatsapp</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <FormControl fullWidth>
                                <InputLabel>Plan</InputLabel>
                                <Select name='plan' label='plan'>
                                    <MenuItem value='basic'>Basic</MenuItem>
                                    <MenuItem value='premium'>Premium</MenuItem>
                                    <MenuItem value='enterprise'>Enterprise</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <TextField
                                label='Number Of Credits'
                                variant='outlined'
                                fullWidth
                                type='number'
                                InputProps={{ inputProps: { min: 0 } }}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <FormControl fullWidth>
                                <InputLabel>Type of Validity</InputLabel>
                                <Select name='Type of Validity' label='Type of Validity'>
                                    <MenuItem value='one'>1 Month</MenuItem>
                                    <MenuItem value='two'>2 Months</MenuItem>
                                    <MenuItem value='unlimit'>Unlimited</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>

                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginTop: 3,
                            flexDirection: { xs: 'column', sm: 'row' },
                            gap: 2
                        }}
                    >
                        <Grid container spacing={2} justifyContent='center'>
                            <Typography variant='h6' color='primary' sx={{ fontWeight: '600' }}>
                                Business Information
                            </Typography>
                            {[...Array(3)].map((_, index) => (
                                <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={3}
                                    key={index}
                                    sx={{ display: 'flex', justifyContent: 'center', my: 4 }}
                                >
                                    <Card
                                        onClick={() => handleCardClick(index)}
                                        variant='outlined'
                                        sx={{
                                            position: 'relative',
                                            borderRadius: '10px',
                                            boxShadow: 3,
                                            width: '100%',
                                            maxWidth: '90%',
                                            minWidth: '200px',
                                            minHeight: '140px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'space-between',
                                            padding: '12px',
                                            transition: '0.3s',
                                            border: selectedCard === index ? '2px solid green' : '1px solid #ddd',
                                            '&:hover': {
                                                boxShadow: 8,
                                                transform: 'scale(1.05)'
                                            }
                                        }}
                                    >
                                        {selectedCard === index && (
                                            <CheckCircleIcon
                                                sx={{
                                                    position: 'absolute',
                                                    top: 8,
                                                    right: 8,
                                                    color: 'green',
                                                    fontSize: '24px'
                                                }}
                                            />
                                        )}

                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between'
                                            }}
                                        >
                                            <Typography
                                                variant='subtitle1'
                                                sx={{
                                                    fontWeight: 'bold',
                                                    fontSize: '1rem',
                                                    color: '#2C3E50',
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis'
                                                }}
                                            >
                                                Pawn Broker
                                            </Typography>
                                            <EditIcon
                                                sx={{
                                                    color: '#a00',
                                                    fontSize: '18px',
                                                    cursor: 'pointer',
                                                    transition: '0.3s',
                                                    marginRight: '28px'
                                                }}
                                            />
                                        </Box>

                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                            <Typography
                                                variant='body2'
                                                color='textSecondary'
                                                sx={{ fontSize: '0.8rem' }}
                                            >
                                                Pba
                                            </Typography>
                                            <Typography
                                                variant='body2'
                                                color='textSecondary'
                                                sx={{ fontSize: '0.8rem' }}
                                            >
                                                sales@tagte.com
                                            </Typography>
                                            <Typography
                                                variant='body2'
                                                color='textSecondary'
                                                sx={{ fontSize: '0.8rem', fontWeight: 'bold' }}
                                            >
                                                Ganesh Enclave, No 40C, Murugan Kovil Street, 1st Floor, Vivekananda
                                                Nagar
                                            </Typography>
                                            <Typography
                                                variant='body2'
                                                color='textSecondary'
                                                sx={{ fontSize: '0.8rem', fontWeight: 'bold' }}
                                            >
                                                21431234
                                            </Typography>
                                            <Typography
                                                variant='body2'
                                                color='textSecondary'
                                                sx={{ fontSize: '0.8rem', fontWeight: 'bold' }}
                                            >
                                                Tamilnadu
                                            </Typography>
                                        </Box>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginTop: 4,
                            paddingTop: 2,
                            borderTop: '1px solid #ddd'
                        }}
                    >
                        <Typography variant='h6'>Grand Total: ₹ {Number('520').toFixed(2)}</Typography>

                        <Box sx={{ display: 'flex', gap: 2 }}>
                            <Button variant='outlined' color='primary'>
                                Cancel
                            </Button>

                            <Button
                                className={classes.animatedButton}
                                variant='contained'
                                color='primary'
                                sx={{
                                    background: 'linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)',
                                    color: '#fff',
                                    '&:hover': {
                                        background: 'linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)'
                                    }
                                }}
                            >
                                Next
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>
        </>
    );
};

export default ProductList;
